import {getCookie, getCookieName} from '../../common/utils/cookieUtils'
import {ApiService} from '../ApiService'
import {UserDto} from './type'

class UserServiceProvider extends ApiService {
  async getMe(): Promise<UserDto> {
    return await this.get<UserDto>(`/user/me`, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }
}

export const UserService = new UserServiceProvider()
